// Refine
import { Refine } from "@refinedev/core";
import { DevtoolsProvider } from "@refinedev/devtools";
import { RefineKbar, RefineKbarProvider } from "@refinedev/kbar";
import routerBindings from "@refinedev/react-router";

// React
import { BrowserRouter, Route, Routes, useLocation } from "react-router";
import { useEffect } from "react";

// Mantine
import { MantineProvider } from "@mantine/core";
import { ThemedLayoutV2 } from "@refinedev/mantine";

// Components
import theme from "@themes/theme-v8";
import { CwiggoHeader } from "@/src/components/header/header";
import { SidebarProvider } from "@/src/contexts/sidebar-context";
import { MobileMenu } from "@/src/components/navigation/mobile-menu";

// Styles
import "@scss/styles.scss";

// Providers
import { authProvider } from "@providers/auth-provider";

// pages
import { HomeIndex } from "@/src/pages/home";
// import { ContactUs } from "@/src/pages/contact";
import { Styles } from "@/src/pages/styles";

// SDK
import { initializeCwiggoSDK } from "@/src/services/cwiggo-sdk";
import { Faq } from "./pages/faq";

// Wrapper component to conditionally render sidebar and header
function LayoutWrapper({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  const isNotHomePage = location.pathname !== "/";

  return (
    <ThemedLayoutV2
      Sider={() => null}
      Header={() => <CwiggoHeader isNotHomePage={isNotHomePage} />}
      initialSiderCollapsed={false}
    >
      {children}
    </ThemedLayoutV2>
  );
}

function App() {
  // Initialize Cwiggo SDK once when app loads
  useEffect(() => {
    initializeCwiggoSDK();
  }, []);

  return (
    <BrowserRouter>
      <MantineProvider theme={theme} defaultColorScheme="dark">
        <RefineKbarProvider>
          <DevtoolsProvider>
            <Refine
              routerProvider={routerBindings}
              authProvider={authProvider}
              options={{
                syncWithLocation: true,
                liveMode: "auto",
                warnWhenUnsavedChanges: true,
                useNewQueryKeys: true,
                projectId: "C7OLTD-uwJiTS-qfJ2XG", //todo: make this into an env variable
              }}
            >
              <SidebarProvider>
                <LayoutWrapper>
                  <Routes>
                    <Route index element={<HomeIndex />} />
                    {/* <Route path="/contact-us" element={<ContactUs isNotHomePage={true} />} /> */}
                    <Route path="/faq" element={<Faq isNotHomePage={true} />} />
                    <Route path="/styles" element={<Styles />} />
                  </Routes>
                </LayoutWrapper>
                <MobileMenu />
              </SidebarProvider>
              <RefineKbar />
            </Refine>
          </DevtoolsProvider>
        </RefineKbarProvider>
      </MantineProvider>
    </BrowserRouter>
  );
}

export default App;
